import { useMemo } from "react";
import { useEnv } from "@/core/env";

/**
 * Resolves a `file_url` from the API (a root-relative ActiveStorage path, e.g.
 * `/rails/active_storage/...`) to an absolute URL on the API's origin.
 *
 * ActiveStorage is mounted at the API host's root, NOT under the `/api` path
 * that `apiUrl` (and the axios baseURL) points at, so resolve against the API
 * *origin*: letting axios prepend baseURL would request `/api/rails/...`, which
 * 404s. And in deployed environments the SPA is served from a different origin
 * than Rails, so a bare relative path would resolve against the SPA and 404.
 */
export const useApiFileHref = (fileUrl?: string | null) => {
  const { apiUrl } = useEnv();
  return useMemo(() => {
    if (!fileUrl) return null;
    let origin: string;
    try {
      origin = new URL(apiUrl).origin;
    } catch {
      origin = window.location.origin;
    }
    try {
      return new URL(fileUrl, origin).toString();
    } catch {
      return fileUrl;
    }
  }, [fileUrl, apiUrl]);
};
